import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { FEEDBACKS_KEYS, listarFeedbacks, criarFeedback, buscarPeriodoAtivo, type CreateFeedbackPayload } from '../api';

export const PERIODO_ATIVO_KEY = ['feedbacks', 'period'] as const;

interface ListParams {
  collaboratorId?: string;
  managerId?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

export function useFeedbacks(params?: ListParams) {
  return useQuery({
    queryKey: FEEDBACKS_KEYS.list(params),
    queryFn: () => listarFeedbacks(params),
  });
}

export function useCriarFeedback() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateFeedbackPayload) => criarFeedback(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: FEEDBACKS_KEYS.all }),
  });
}

export function usePeriodoAtivo() {
  return useQuery({
    queryKey: PERIODO_ATIVO_KEY,
    queryFn: buscarPeriodoAtivo,
  });
}
